import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { KickOffReturnPlaySelection } from "./KickOffReturnPlaySelection";
import { KickOffReturnLog } from "./KickOffReturnLog";
import { PenaltyLog } from "../Components/PenaltyLog";
import { useDepthChart } from "../../../../contexts/DepthChartContext";
import { useLogger } from "../../../../contexts/LoggerContext";

export const KickOffReturnLogger = () => {
  const [expandedAccordion, setExpandedAccordion] = useState<string | false>(
    "play-selection"
  );
  const { kickOffReturnPlayers } = useDepthChart();
  const { clearSelections } = useLogger();


  const handleAccordionChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedAccordion(isExpanded ? panel : false);
    };

  useEffect(() => {
    if (clearSelections) {
      setExpandedAccordion("play-selection");
    }
  }, [clearSelections]);

  return (
    <Paper elevation={3} sx={{ p: 1, margin: '0 auto' }}>
      <Box>
        {/* Play Selection */}
        <Accordion
          expanded={expandedAccordion === "play-selection"}
          onChange={handleAccordionChange("play-selection")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="play-selection-content"
            id="play-selection-header"
          >
            <Typography>Play Selection</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <KickOffReturnPlaySelection />
          </AccordionDetails>
        </Accordion>

        {/* Return Log */}
        <Accordion
          expanded={expandedAccordion === "run-log"}
          onChange={handleAccordionChange("run-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="run-log-content"
            id="run-log-header"
          >
            <Typography>Return Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <KickOffReturnLog />
          </AccordionDetails>
        </Accordion>

        {/* Penalty Log */}
        <Accordion
          expanded={expandedAccordion === "penalty-log"}
          onChange={handleAccordionChange("penalty-log")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="penalty-log-content" id="penalty-log-header">
            <Typography>Penalty Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <PenaltyLog players={kickOffReturnPlayers} />
          </AccordionDetails>
        </Accordion>
      </Box>
    </Paper>
  );
};
